import { Model, attr, belongsTo } from '@elatonsev/js-models';
import PhotoModel from './PhotoModel';

export default class VendorModel extends Model {
  name = attr('string');
  public_api_key = attr('string');
  photo = belongsTo(PhotoModel);
}